export const Marquee = ({ items, mono }) => (
  <div className={`marquee-wrap py-1 ${mono ? "marquee-mono" : ""}`} data-testid="editorial-marquee">
    <div className="marquee-track">
      {[0, 1].map((seg) => (
        <span key={seg} aria-hidden={seg === 1} className="inline-flex">
          {items.map((t, i) => (
            <span key={i} className={`marquee-item ${i % 2 ? "text-outline" : "text-white"}`}>
              {t}
              <em>◆</em>
            </span>
          ))}
        </span>
      ))}
    </div>
  </div>
);
